var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-list"},[_c('div',{staticClass:"md-layout",staticStyle:{"padding":"2px 10px","box-sizing":"border-box"}},[_c('order-content',{attrs:{"isManage":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }